import { Routes } from '@angular/router';
import { IntegrationSettingsComponent } from './integration-settings.component';
import { userRolesAndPermissionsGuard } from '@core/guards/user-roles-and-permissions.guard';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { VismaIntegrationComponent } from './visma-integration/visma-integration.component';
import { pendingChangesGuard } from '@core/guards/pending-changes.guard';
import { VippsIntegrationComponent } from './vipps-integration/vipps-integration.component';
import { userDomainGuard } from '@core/guards/user-domain.guard';
import { supportUserGuard } from '@core/guards/support-user.guard';

export const IntegrationSettingsRouteName = {
  Main: 'integration-settings',
  VismaExpense: 'visma-expense',
  VippsIntegration: 'vipps',
};
export const INTEGRATION_SETTINGS_ROUTES: Routes = [
  {
    path: '',
    component: IntegrationSettingsComponent,
    canActivate: [
      () =>
        userRolesAndPermissionsGuard([
          RolesAndPermissions.IntegrationSettingsRead,
        ]),
    ],
    children: [
      {
        path: '',
        redirectTo: IntegrationSettingsRouteName.VippsIntegration,
        pathMatch: 'full',
      },
      {
        path: IntegrationSettingsRouteName.VismaExpense,
        component: VismaIntegrationComponent,
        canDeactivate: [
          (component: VismaIntegrationComponent) =>
            pendingChangesGuard(component),
        ],
      },
      {
        path: IntegrationSettingsRouteName.VippsIntegration,
        component: VippsIntegrationComponent,
        canActivate: [() => userDomainGuard(2), () => supportUserGuard()],
        canDeactivate: [
          (component: VippsIntegrationComponent) =>
            pendingChangesGuard(component),
        ],
      },
    ],
  },
];
